export default "<div class=\"blue\">\n    <div class=\"white\">\n        <tc-reporting-list></tc-reporting-list>\n    </div>\n</div>";